import { Button, Popover } from "@mui/material";
import { useDeleteWithConfirmController } from "ra-core";
import React, { useState } from "react";


const DeleteButton = ({
  resource,
  record,
  basePath,
  redirect,
  onClick,
  onSuccess,
  onFailure,
  ...rest
}: any) => {
  const {
    open,
    handleDialogOpen,
    handleDialogClose,
    handleDelete,
    loading,
  } = useDeleteWithConfirmController({
    resource,
    record,
    redirect,
    basePath,
    onClick,
    onSuccess,
    onFailure,
  });

  const [anchorEl, setAnchorEl] = useState<Element | null>(null)
  const handleClick = (event: React.SyntheticEvent<Element, Event>) => {
    setAnchorEl(event.currentTarget)
    handleDialogOpen(event)
  }
  const handleClose = (event: React.SyntheticEvent<Element, Event>) => {
    handleDialogClose(event)
    setAnchorEl(null)
  }

  return (
    <>
      <Button
        onClick={handleClick}
        label="ra.action.delete"
        {...rest}
      >
        Delete
      </Button>
      <Popover
        id={"id"}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Button color="primary" disabled={loading} onClick={handleDelete}>Confirm</Button>
        <Button color="inherit" onClick={handleClose}>Cancel</Button>
      </Popover>
    </>
  );
};

export default DeleteButton;
